import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const DisplayGuideHelper = ({ integrationTitle, urlHelper }) => {
  const theme = useTheme();
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100%',
        borderLeft: `1px solid ${theme.palette.divider}`,
        pl: 2
      }}
      spacing={2}
    >
      <Typography
        variant="overline"
        color={theme.palette.grey[600]}
        textAlign="center"
      >
        Visita el contenido de ayuda para integrar {integrationTitle}
      </Typography>
      <Button
        startIcon={<OpenInNewIcon />}
        variant="contained"
        href={urlHelper}
        target="_blank"
      >
        Ver ayuda
      </Button>
    </Stack>
  );
};

DisplayGuideHelper.propTypes = {
  integrationTitle: PropTypes.string,
  urlHelper: PropTypes.string
};

export default DisplayGuideHelper;
